import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg leading-7 font-medium text-black pb-6" }, "Date when should move to the next action", -1)
const _hoisted_3 = { class: "flex flex-col gap-y-5" }

import { watch } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { CalendarIcon, ClockIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { dateTimeConverter } from "@/shared/utils/helpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarDateComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()

watch(
    () => [workflowStore.modelValue?.date, workflowStore.modelValue?.time],
    () => {
        //convert time and date into ISO date
        if (workflowStore.modelValue?.date && workflowStore.modelValue?.time) {
            workflowStore.modelValue.dateTime = dateTimeConverter(
                workflowStore.modelValue.time,
                workflowStore.modelValue.date
            )
        }
        if (workflowStore.modelValue?.date) {
            workflowStore.modelValue.dateTime = dateTimeConverter("10:00", workflowStore.modelValue.date)
            workflowStore.areButtonDisabled = false
        }
    }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(GgmsInput, {
        modelValue: _unref(workflowStore).modelValue.date,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.date) = $event)),
        label: "Select day",
        type: "date",
        iconStart: _unref(CalendarIcon)
      }, null, 8, ["modelValue", "iconStart"]),
      _createVNode(GgmsInput, {
        modelValue: _unref(workflowStore).modelValue.time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(workflowStore).modelValue.time) = $event)),
        label: "Select time",
        type: "time",
        iconStart: _unref(ClockIcon)
      }, null, 8, ["modelValue", "iconStart"])
    ])
  ]))
}
}

})